import { Container, Grid, Icon } from "@material-ui/core";
import { useContext, useEffect } from "react";
import Btn from "../../../components/buttons/Btn";
import Card from "../../../components/cards/Card";
import TableDefault from "../../../components/grid/TableDefault";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import { Margin } from "../../financeiro/nfe/styles/Emissao";
import { TypographyStyled } from "../../financeiro/nfe/styles/TableEmails";
import { TemplateEmailsContext } from "../contexts/TemplateEmailsContext";
import useTemplatesEmailsController from "../controller/TemplatesEmailsController";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { useHistory } from "react-router-dom";

export default function TableEmails() {
  const { tableEmailsItems } = useContext(TemplateEmailsContext);
  const { initHeandleInputs } = useTemplatesEmailsController();
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();

  useEffect(() => {
    if (queryParams.empresa_cnpj) {
      initHeandleInputs("templatesEmails");
    }
  }, [initHeandleInputs, queryParams.empresa_cnpj]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlinedIcon />,
              name: "Editar",
              action: () => push("cadastro", { item }),
            },
          ]}
        />
      ),
    },
    {
      label: "Rotinas",
      align: "left",
      format: (value) => {
        return value?.type?.description;
      },
      disablePadding: false,
    },
    {
      label: "Descrição",
      align: "left",
      format: (value) => {
        return value?.description;
      },
      disablePadding: false,
    },
  ];

  return (
    <>
      <Margin top={80}>
        <Container maxWidth="xl">
          <Grid item container spacing={1}>
            <Card fullWidth={true}>
              <Grid item container xs spacing={1}>
                <Grid item container xs={12}>
                  <Grid item xs>
                    <TypographyStyled>CADASTRO EMAIL</TypographyStyled>
                  </Grid>
                  <Grid item xs></Grid>
                  <Grid item xs={2}>
                    <Btn
                      label="NOVO"
                      onClick={() => push("cadastro")}
                      startIcon={<Icon>add</Icon>}
                      full="true"
                      bgcolor="darkgreen"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TableDefault
                    columns={columns}
                    values={tableEmailsItems}
                    tableTitle=""
                    smallFont
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Container>
      </Margin>
    </>
  );
}
